import { Injector, NgModule } from '@angular/core';
import { LocationsModule } from './locations/locations.module';
import { AddressesModule } from './addresses/addresses.module';
import { TaxModule } from './tax/tax.module';
import {
    AbstractPluginsModule,
    BootstrapModule,
    BootstrapModuleContract,
    MenuService,
    PluginService,
} from '@kaiser-software/chassis-core';

@NgModule({
    imports: [
        AbstractPluginsModule,
        LocationsModule,
        AddressesModule,
        TaxModule,
    ],
    declarations: [],
    providers: [],
    exports: [
        LocationsModule,
        AddressesModule,
        TaxModule,
    ],
})
export class DonnaCoreBootstrapModule extends BootstrapModule implements BootstrapModuleContract {
    public boot(injector: Injector) {
    }

    public plugins(plugins: PluginService) {
    }

    public menus(menus: MenuService) {
    }
}



// WEBPACK FOOTER //
// ./libs/donna-core/src/app/core-bootstrap.module.ts